import { Injectable } from '@angular/core';
import { UserHttpModel } from '@examdojo/models/user';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';
import { UpdateUserReviewPermissionsInput } from './review-permissions.model';

@Injectable({ providedIn: 'root' })
export class UserReviewModeBindingsHttpService extends SupabaseBaseHttpService<'user_review_mode_bindings', 'review'> {
  readonly schema = 'review';
  readonly tableName = 'user_review_mode_bindings';

  fetchUserPermissions(userId: UserHttpModel['id']) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq('user_id', userId)
        .throwOnError()
        .then((response) => response.data!),
    );
  }

  updateUsersReviewPermissions(userId: UserHttpModel['id'], syllabusPermissions: UpdateUserReviewPermissionsInput) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('update_user_review_permissions', {
          p_user_id: userId,
          p_syllabus_permissions: syllabusPermissions.map((permission) => ({
            syllabus_id: permission.syllabusId,
            permissions: permission.permissions,
          })),
        })
        .throwOnError()
        .then((response) => response.data),
    );
  }
}
